"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var FormControlLabel_1 = __importDefault(require("@material-ui/core/FormControlLabel"));
var ReactEasyForm_1 = require("../ReactEasyForm");
var ErrorText_1 = __importDefault(require("../helpers/ErrorText"));
var react_hook_form_1 = require("react-hook-form");
var core_2 = require("@material-ui/core");
function CheckboxesGroup(props) {
    var _a;
    var possibleValues = props.options.map(function (option) {
        return option.value;
    });
    if (props.defaultValues) {
        props.defaultValues.forEach(function (value) {
            if (!possibleValues.includes(value)) {
                throw new Error("Material-ui-form: the default value \"" + value + "\" is not found in the possible values specified in the options \"" + JSON.stringify(possibleValues) + "\"");
            }
        });
    }
    var form = react_1.useContext(ReactEasyForm_1.FormContext);
    if (!form) {
        throw new Error("form is not defined");
    }
    var errorActive = false;
    var errorText = undefined;
    if (form.errors[props.name] !== undefined) {
        errorActive = true;
        errorText = form.errors[props.name].message;
    }
    var handleCheck = function (checkedValue) {
        var values = form.getValues(props.name);
        var newCheckedValues = (values === null || values === void 0 ? void 0 : values.includes(checkedValue)) ? values === null || values === void 0 ? void 0 : values.filter(function (id) { return id !== checkedValue; }) : __spreadArrays((values !== null && values !== void 0 ? values : []), [checkedValue]);
        if (newCheckedValues.length === 0) {
            return undefined;
        }
        return newCheckedValues;
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_hook_form_1.Controller, { name: props.name, defaultValue: (_a = props.defaultValues) !== null && _a !== void 0 ? _a : "", rules: props.rules, render: function (_a) {
                var onChange = _a.onChange;
                return (react_1.default.createElement(core_2.FormGroup, __assign({}, props.muiFormGroupProps), props.options.map(function (option) {
                    var _a;
                    return (react_1.default.createElement(FormControlLabel_1.default, __assign({ control: react_1.default.createElement(core_1.Checkbox, __assign({ onChange: function () { return onChange(handleCheck(option.value)); }, defaultChecked: ((_a = props.defaultValues) === null || _a === void 0 ? void 0 : _a.includes(option.value)) ? true : false }, props.muiCheckboxProps)), key: option.value, label: option.label }, props.muiFormControlLabelProps)));
                })));
            }, control: form.control }),
        react_1.default.createElement(ErrorText_1.default, { active: errorActive, text: errorText })));
}
exports.default = CheckboxesGroup;
